var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 80,
    viewBox: "0 0 327 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5625 50.2676L51.6843 62.7905V34.3672L30.5625 50.2676Z",
    fill: "url(#paint0_linear_9289_8931)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1075 4.4375V31.7936L30.5625 50.2644V22.4798L63.1075 4.4375Z",
    fill: "#48A63D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5593 27.4917L70.4375 14.9688V43.3882L91.5593 27.4917Z",
    fill: "#0D4E8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0156 73.319V45.9591L91.5606 27.4922V55.2767L59.0156 73.319Z",
    fill: "url(#paint1_linear_9289_8931)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.125 28.4062H113.721C118.828 28.4062 122.005 31.2597 122.005 35.5857V35.6469C122.005 40.4625 118.082 42.9794 113.286 42.9794H108.955V49.8796H105.125V28.4062ZM113.414 39.5751C116.311 39.5751 118.117 37.9801 118.117 35.7425V35.6813C118.117 33.1645 116.28 31.8487 113.414 31.8487H108.959V39.579H113.414V39.5751Z",
    fill: "#020304"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.062 27.4844H127.83V49.8757H124.062V27.4844Z",
    fill: "#020304"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.016 45.2074V45.1462C130.016 41.6502 132.789 39.9328 136.805 39.9328C138.642 39.9328 139.951 40.2082 141.229 40.606V40.2082C141.229 37.9094 139.796 36.6816 137.147 36.6816C135.31 36.6816 133.939 37.0794 132.443 37.6952L131.445 34.7806C133.251 33.9811 135.026 33.4609 137.644 33.4609C140.107 33.4609 141.944 34.1035 143.093 35.2701C144.309 36.4368 144.868 38.1542 144.868 40.2694V49.87H141.194V47.8466C140.072 49.1662 138.359 50.2104 135.838 50.2104C132.758 50.2104 130.016 48.4586 130.016 45.2074ZM141.291 44.0408V42.9354C140.324 42.5682 139.05 42.2928 137.555 42.2928C135.123 42.2928 133.69 43.3064 133.69 44.9932V45.0544C133.69 46.6188 135.092 47.51 136.898 47.51C139.392 47.51 141.291 46.0986 141.291 44.0408Z",
    fill: "#020304"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.734 33.6803H151.502V36.1666C152.562 34.6634 154.089 33.3438 156.641 33.3438C160.346 33.3438 162.498 35.7994 162.498 39.5402V49.8791H158.73V40.6724C158.73 38.1556 157.452 36.7135 155.211 36.7135C153.032 36.7135 151.506 38.2168 151.506 40.7336V49.8752H147.738V33.6803H147.734Z",
    fill: "#020304"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.391 33.6803H169.158V36.1666C170.219 34.6634 171.745 33.3438 174.297 33.3438C178.002 33.3438 180.154 35.7994 180.154 39.5402V49.8791H176.387V40.6724C176.387 38.1556 175.109 36.7135 172.868 36.7135C170.689 36.7135 169.162 38.2168 169.162 40.7336V49.8752H165.395V33.6803H165.391Z",
    fill: "#020304"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.109 27.6719H187.161V31.1985H183.109V27.6719ZM183.265 33.6847H187.032V49.8796H183.265V33.6847Z",
    fill: "#020304"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M190.312 33.6803H194.08V36.1666C195.14 34.6634 196.667 33.3438 199.219 33.3438C202.924 33.3438 205.076 35.7994 205.076 39.5402V49.8791H201.308V40.6724C201.308 38.1556 200.031 36.7135 197.789 36.7135C195.61 36.7135 194.084 38.2168 194.084 40.7336V49.8752H190.316V33.6803H190.312Z",
    fill: "#020304"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.937 52.9083L209.339 50.116C211.114 51.1909 212.951 51.8334 215.196 51.8334C218.56 51.8334 220.397 50.116 220.397 46.8648V45.6064C219.026 47.3544 217.313 48.5822 214.602 48.5822C210.737 48.5822 207.125 45.7594 207.125 41.005V40.9438C207.125 36.1588 210.768 33.3359 214.602 33.3359C217.375 33.3359 219.088 34.5944 220.366 36.0976V33.6725H224.134V46.555C224.134 49.286 223.419 51.3094 222.048 52.6596C220.552 54.1322 218.249 54.836 215.289 54.836C212.578 54.8399 210.057 54.1667 207.937 52.9083ZM220.428 40.9782V40.917C220.428 38.2778 218.218 36.4686 215.6 36.4686C212.982 36.4686 210.928 38.2472 210.928 40.917V40.9782C210.928 43.6174 213.013 45.4266 215.6 45.4266C218.218 45.4228 220.428 43.6136 220.428 40.9782Z",
    fill: "#020304"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.082 28.4062H235.994C240.791 28.4062 244.092 30.8313 244.092 34.9699V35.0311C244.092 39.5407 240.138 41.8701 235.586 41.8701H229.698V49.8758H228.078V28.4062H228.082ZM235.683 40.4013C239.734 40.4013 242.473 38.3167 242.473 35.1267V35.0655C242.473 31.6613 239.793 29.8827 235.87 29.8827H229.702V40.4052H235.683V40.4013Z",
    fill: "#020304"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M245.656 42.1176V42.0564C245.656 37.6692 249.113 33.8672 253.848 33.8672C258.552 33.8672 261.977 37.608 261.977 41.9952V42.0564C261.977 46.4437 258.52 50.2457 253.786 50.2457C249.082 50.2457 245.656 46.5049 245.656 42.1176ZM260.327 42.1176V42.0564C260.327 38.285 257.46 35.2786 253.786 35.2786C250.018 35.2786 247.307 38.3156 247.307 41.9952V42.0564C247.307 45.8278 250.173 48.8343 253.848 48.8343C257.619 48.8381 260.327 45.8011 260.327 42.1176Z",
    fill: "#020304"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.031 34.2344H266.558V38.6829C267.805 35.8906 270.45 33.8672 273.6 33.9896V35.6458H273.44C269.766 35.6458 266.558 38.3769 266.558 43.4679V49.8785H265.031V34.2344Z",
    fill: "#020304"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.678 45.8615V35.6144H274.375V34.2336H276.678V29.2344H278.205V34.2336H283.782V35.6144H278.205V45.7047C278.205 47.9461 279.545 48.7417 281.382 48.7417C282.159 48.7417 282.815 48.5887 283.716 48.1909V49.6023C282.905 49.9695 282.128 50.1531 281.129 50.1531C278.671 50.1531 276.678 48.8373 276.678 45.8615Z",
    fill: "#020304"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.617 45.333V45.2718C285.617 42.0206 288.453 40.1808 292.562 40.1808C294.772 40.1808 296.299 40.4562 297.825 40.854V40.1808C297.825 37.0214 295.863 35.3958 292.593 35.3958C290.663 35.3958 289.074 35.916 287.61 36.6542L287.05 35.3346C288.794 34.5352 290.507 33.9844 292.69 33.9844C294.838 33.9844 296.551 34.5658 297.705 35.7018C298.765 36.746 299.324 38.188 299.324 40.1196V49.8733H297.829V47.2646C296.737 48.7679 294.776 50.2405 291.754 50.2405C288.794 50.2405 285.617 48.5842 285.617 45.333ZM297.86 44.0172V42.2386C296.52 41.902 294.745 41.5348 292.473 41.5348C289.109 41.5348 287.241 43.0075 287.241 45.1839V45.2451C287.241 47.5133 289.42 48.8329 291.851 48.8329C295.091 48.8329 297.86 46.8668 297.86 44.0172Z",
    fill: "#020304"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.375 27.4844H304.901V49.8757H303.375V27.4844Z",
    fill: "#020304"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9289_8931",
    x1: 30.5607,
    y1: 48.5794,
    x2: 51.6841,
    y2: 48.5794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#10599D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#105A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9672,
    stopColor: "#105A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9289_8931",
    x1: 59.0148,
    y1: 50.4043,
    x2: 91.5622,
    y2: 50.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#10599D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#105A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9672,
    stopColor: "#105A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#105A9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpLogoBlack);
export default __webpack_public_path__ + "static/media/PPLogo_Black.03c9bdbe4f5bc1dc2cad7841febb6fb8.svg";
export { ForwardRef as ReactComponent };